import { useLayoutEffect, useEffect } from 'react';

/**
 * If we want to make sure a effect is run on first render,
 * so simultaneous with the DOM rendering,
 * but also make sure frameworks like NextJS stay functional we can check for window and return the correct effect.
 *
 * https://reactjs.org/link/uselayouteffect-ssr Some common fixes and comments can be found here.
 */ const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export { useIsomorphicLayoutEffect as default };
//# sourceMappingURL=use-isomorphic-layout-effect.js.map
